import BlazeLink from '../components/BlazeLink';
import { HERO_WRAPPER, IMAGE_WRAPPER } from '../constants';
const buildImageProperties = ({
  href,
  name,
  enableLightbox,
  isHero = false
}) => {
  const className = isHero ? HERO_WRAPPER : IMAGE_WRAPPER;
  const urlProps = {
    href,
    title: name,
    className,
    isHero
  };
  const isLink = href && !enableLightbox;
  const ImgWrapper = isLink ? BlazeLink : 'div';
  const imgWrapperProps = isLink ? urlProps : {
    className
  };
  const lightboxImgProps = href ? urlProps : {};
  return {
    ImgWrapper,
    imgWrapperProps,
    lightboxImgProps
  };
};
export default buildImageProperties;
//# sourceMappingURL=build-image-properties.js.map